var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArlBottle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 148,
    height: 160,
    viewBox: "0 0 148 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_821_126)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114.969 90.0643C114.46 89.4337 113.504 89.4337 112.986 90.0643C110.535 93.0952 104.402 101.374 104.402 108.087C104.402 113.376 108.694 117.658 113.972 117.658C119.25 117.658 123.542 113.376 123.542 108.087C123.542 101.374 117.399 93.0952 114.959 90.0643H114.969Z",
    fill: "#ABDAE2",
    stroke: "#ABDAE2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.484 100.296C118.437 98.3434 117.257 96.5228 116.189 95.0175",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9266 129.355C48.6012 131.369 49.9741 133.26 51.9877 133.576C54.0013 133.901 55.8929 132.528 56.2082 130.514C56.5336 128.5 55.1607 126.609 53.1471 126.293C51.1335 125.968 49.2419 127.341 48.9266 129.355Z",
    fill: "white",
    stroke: "#ABDAE2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.6033 101.242C83.3321 100.744 82.3863 99.798 81.888 98.5368C81.7456 98.1808 81.2575 98.1808 81.1151 98.5368C80.6168 99.7878 79.6608 100.744 78.3998 101.242C78.0438 101.385 78.0438 101.873 78.3998 102.015C79.671 102.514 80.6269 103.46 81.1354 104.721C81.2778 105.077 81.766 105.077 81.9083 104.721C82.4066 103.46 83.3524 102.524 84.6033 102.025C84.9592 101.883 84.9592 101.395 84.6033 101.252V101.242Z",
    stroke: "#ABDAE2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.724 119.204C140.453 118.706 139.507 117.76 139.009 116.499C138.867 116.143 138.379 116.143 138.236 116.499C137.738 117.75 136.782 118.706 135.521 119.204C135.165 119.346 135.165 119.835 135.521 119.977C136.792 120.475 137.748 121.421 138.257 122.683C138.399 123.039 138.887 123.039 139.029 122.683C139.528 121.421 140.474 120.486 141.724 119.987C142.08 119.845 142.08 119.357 141.724 119.214V119.204Z",
    fill: "#ABDAE2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M88.4058 131.948L80.5039 133.535C85.5583 152.046 103.538 160.946 119.861 157.935C107.159 156.806 93.033 145.13 88.4058 131.948Z",
    fill: "#ABDAE2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.5039 133.535C84.9989 149.982 99.2162 158.474 113.494 158.474C127.773 158.474 141.492 150.327 146.475 133.535C113.494 125.022 80.5039 133.535 80.5039 133.535Z",
    stroke: "#314C7E",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.1914 146.178C98.1678 149.707 102.927 152.067 107.951 153.216",
    stroke: "#314C7E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.3477 142.058C90.6934 142.506 91.0494 142.933 91.4053 143.35",
    stroke: "#314C7E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.5039 133.535C93.3584 136.739 106.62 138.061 119.861 137.441C128.841 137.024 137.759 135.712 146.475 133.535",
    stroke: "#314C7E",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.398 69.112L70.089 80.1984C68.8279 80.7273 67.4041 80.6459 66.2143 79.9848L3.79252 45.1084C1.94163 44.071 1.07721 41.874 1.73824 39.8602C3.92473 33.2084 9.85368 18.1044 22.3421 3.1022C23.7048 1.47484 26.0439 1.04766 27.8948 2.0851L90.2047 36.9004C91.4149 37.5819 92.2488 38.7922 92.4318 40.1653L96.3879 69.1018L96.398 69.112Z",
    fill: "white",
    stroke: "#314C7E",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6582 69.5594L51.0718 67.0269",
    stroke: "#314C7E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.5332 71.7259L55.8011 67.6779",
    stroke: "#314C7E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1465 50.8855C14.1465 50.8855 21.0212 26.4242 38.1877 7.8418",
    stroke: "#314C7E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8828 75.8859L82.924 32.832",
    stroke: "#314C7E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.66 43.664L42.0938 27.543",
    stroke: "#ABDAE2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1185 37.9683L47.5625 21.8473",
    stroke: "#ABDAE2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.207 76.3536L103.977 78.2251L106.397 68.4203L104.526 66.8438L99.207 76.3536Z",
    fill: "#ABDAE2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.547 63.9756L94.6387 74.5636L112.517 81.5714L115.893 75.5298L100.547 63.9756Z",
    stroke: "#314C7E",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.7129 74.198L94.5105 54.8676L106.407 61.5147L96.9539 78.4387C96.2099 79.7706 94.5266 80.2399 93.2037 79.5007L83.7129 74.198Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.7153 74.1975L92.5324 79.1304C94.2307 80.0763 96.3766 79.4762 97.3223 77.7777L97.963 76.6284L86.0645 69.9867L83.7051 74.2178L83.7153 74.1975Z",
    fill: "#ABDAE2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.7129 74.198L94.5105 54.8676L104.001 60.1704C105.333 60.9144 105.802 62.5979 105.063 63.921L96.9539 78.4387C96.2099 79.7706 94.5266 80.2399 93.2037 79.5007L83.7129 74.198Z",
    stroke: "#314C7E",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.685 62.8162L102.288 50.8042C101.312 47.3563 103.315 43.7761 106.763 42.7996C110.21 41.8232 113.79 43.8269 114.766 47.2749L118.163 59.2868",
    stroke: "#314C7E",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.106 53.0927L144.157 58.1477L137.516 70.0477L118.184 59.2461L124.835 47.3461L129.441 49.9295L136.784 40.1857L143.994 44.2134L141.401 50.8449",
    stroke: "#314C7E",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.38 82.3343L22.9629 78.7439",
    stroke: "#ABDAE2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.375 83.7481L27.9649 77.3302",
    stroke: "#ABDAE2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.634 18.9994C110.404 19.5486 109.865 20.9929 110.414 22.2236C110.963 23.4543 112.407 23.9934 113.638 23.4441C114.868 22.8949 115.407 21.4506 114.858 20.2199C114.309 18.9892 112.865 18.4502 111.634 18.9994Z",
    stroke: "#ABDAE2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_821_126"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 148,
    height: 160,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArlBottle);
export default __webpack_public_path__ + "static/media/arl-bottle.022bec078ec60d2a3ae25ba384781949.svg";
export { ForwardRef as ReactComponent };